const nonTechnicalEvents = [
    {
        id:1,
        name:'Event 1',
        img:'https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere porro placeat odio debitis quia non architecto cupiditate! Explicabo animi.',
        date:'24th Jan 2024',
        timings:'9:00pm --> 9:00am',
    },
    {
        id:2,
        name:'Event 2',
        img:'https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere porro placeat odio debitis quia non architecto cupiditate! Explicabo animi.',
        date:'24th Jan 2024',
        timings:'9:00pm --> 9:00am',
    },
    {
        id:3,
        name:'Event 3',
        img:'https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere porro placeat odio debitis quia non architecto cupiditate! Explicabo animi.',
        date:'24th Jan 2024',
        timings:'9:00pm --> 9:00am',
    },
    {
        id:4,
        name:'Event 4',
        img:'https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere porro placeat odio debitis quia non architecto cupiditate! Explicabo animi.',
        date:'24th Jan 2024',
        timings:'9:00pm --> 9:00am',
    },
    {
        id:5,
        name:'Event 5',
        img:'https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere porro placeat odio debitis quia non architecto cupiditate! Explicabo animi.',
        date:'24th Jan 2024',
        timings:'9:00pm --> 9:00am',
    },
    {
        id:6,
        name:'Event 6',
        img:'https://cdn.vectorstock.com/i/preview-1x/76/49/binary-code-digital-technology-background-vector-25687649.jpg',
        description:'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere porro placeat odio debitis quia non architecto cupiditate! Explicabo animi.',
        date:'24th Jan 2024',
        timings:'9:00pm --> 9:00am',
    },
]

export default nonTechnicalEvents